import { ReportFeatures } from '@hcs/types';

export const DOWNLOAD_REPORT_FEATURES = [
  ReportFeatures.OutputPdf,
  ReportFeatures.OutputExcel,
];
